import { RefObject } from 'react'

import FullCalendar from '@fullcalendar/react'

export interface TimeslotContent {
	id?: number
	type: string // 'clear', 'clouds', 'rain', 'snow', 'low', 'medium', 'high'
	volume: number
	min_percentage?: number
	max_percentage?: number
	playlists: Array<{
		id: number
		percentage: number
	}>
}

export interface CalendarEvent {
	id: string
	timeslotId?: number
	timeslotContentId?: number
	title: string
	description: string
	start: Date
	end: Date
	color: string
	backgroundColor?: string
	gradientColors?: string[] // For smart slots: [color1, color2] to create gradient
	playlists?: Array<{
		id: number
		percentage: number
	}>
	repeatDays?: string[] // e.g., ['monday', 'wednesday', 'friday']
	rrule?: any // RRULE object for recurrence
	duration?: any // Duration for recurring events
	startTime?: string // Start time for recurring events
	volume?: number // Playlist volume (0-100)
	slotType?: 'regular' | 'smart' // Slot type: regular or smart (weather/occupancy)
	smartSlotConfig?: {
		variant: 'weather' | 'occupation'
		condition: string // 'cloudy' | 'sunny' | 'rainy' | 'snowy' | 'low' | 'medium' | 'high'
	}
	// For smart slots - contains all conditions/levels
	timeslotName?: string // e.g., "Slot 1"
	timeslotContents?: TimeslotContent[] // Array of content per condition/level
}

export type calendarRef = RefObject<FullCalendar | null>

export const earliestTime = 0
export const latestTime = 1439

export const COLOR_PALETTE = [
	'#BF199B',
	'#5F39BF',
	'#00B4BF',
	'#31AC9E',
	'#C4A31D',
]

export const initialEvents: CalendarEvent[] = []

export const months = [
	{
		value: '1',
		label: 'January',
	},
	{
		value: '2',
		label: 'February',
	},
	{
		value: '3',
		label: 'March',
	},
	{
		value: '4',
		label: 'April',
	},
	{
		value: '5',
		label: 'May',
	},
	{
		value: '6',
		label: 'June',
	},
	{
		value: '7',
		label: 'July',
	},
	{
		value: '8',
		label: 'August',
	},
	{
		value: '9',
		label: 'September',
	},
	{
		value: '10',
		label: 'October',
	},
	{
		value: '11',
		label: 'November',
	},
	{
		value: '12',
		label: 'December',
	},
]
